export default __webpack_public_path__ + "static/media/main_level_test01_kr.a7bf6673.png";